import { largeCornerRadius, neutralAttributeColour, white } from 'Theme';

const styles = {
  avatar: {
    bgcolor: '#ffffff5e',
    height: 80,
    width: 80,
  },
  avatarContainer: {
    alignItems: 'flex-end',
    alignSelf: 'flex-end',
  },
  button: {
    color: white,
    fontWeight: '600',
  },
  card: {
    bgcolor: neutralAttributeColour,
    borderRadius: largeCornerRadius,
    color: white,
  },
  chipContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  contents: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    px: 2,
  },
  metaBlock: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '1rem',
    marginTop: '0px',
  },
  metaLabel: {
    color: white,
  },
  subtitle: {
    color: white,
    fontSize: '1rem',
  },
  title: {
    color: white,
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
};

export default styles;
